<section class="py-5">
    <div class="py-3 container">
        <div class="row">
            <div class="col-md-12">
                <div class="title">
                    <h1 class="fw-bold text-black">Shipping Policy</h1>
                </div>

                <div class="py-4 mb-5">

                    <p class="txt-description mb-4 text-secondary">
                        <strong>Illusbook</strong> provides digital illustrations and assets that are available for immediate download or
                        access upon successful subscription or purchase.
                    </p>

                    <p class="txt-description mb-4 text-secondary">
                        As we deal exclusively in digital goods, there is no physical shipping involved.
                    </p>

                    <p class="txt-description mb-4 text-secondary">You’ll receive instant access to your purchased
                        illustrations via your account dashboard.
                        If you experience any issues accessing your assets, please contact our support team at <a
                            class="un-link bold" href="mailto:support@illusbook.com">support&#64;illusbook.com</a></p>




                </div>
            </div>
        </div>
    </div>
</section>